export const forEcommerceListing = [
	{
		icon: '🔹',
		subtitle: 'forEcommerceData_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'forEcommerceData_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'forEcommerceData_subtitle3',
	},
	{
		icon: '🔹',
		subtitle: 'forEcommerceData_subtitle4',
	},
];
